import endpoint from "../../config/endpoints";

export const dashboardJson = {
  showSaveNextBtn: true,
  showAddButton: true,
  primaryOrderLatestList: [
    {
      label: "From Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "fromdate",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "todate-le",
    },
    {
      label: "To Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "todate",
      onSubmit: "compare",
      onSubmitParameter: "fromdate-ge",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "fromdate-ge",
    },
    {
      label: "Status",
      controlType: "autocomplete",
      placeHolder: "Select Status",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "statusList",
      dataKey: "status",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],
  secondaryOrderBillListOutletWise: [
    {
      label: "Search By",
      controlType: "radiogroup",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
     
      dataKey: "flag",
      tableDataKey: "Outlet wise",
      defaultValue: "1",
      radioGroupItems: [
        {
          label: "Bill number wise",
          value: "1",
        },
        {
          label: "Outlet wise",
          value: "0",
        },
      ],
      isMandatory: true,
    },
    {
      label: "Status",
      controlType: "autocomplete",
      placeHolder: "Select Status",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "statusListForBill",
      dataKey: "status",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "From Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "fromdate",
     
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "todate-le",
    },
    {
      label: "To Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "todate",
      onSubmit: "compare",
      onSubmitParameter: "fromdate-ge",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "fromdate-ge",
    },

    {
      label: "Outlet",
      controlType: "multiSelect",
      placeHolder: "Select Outlet",
        md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      dataKey: "outletIds",
      masterName: "outletDetail",
      isRootLevelKey: true,
      isMandatory: true,
    },
   
    
  ],
  secondaryOrderBillList: [
    {
      label: "Search By",
      controlType: "radiogroup",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "flag",
      tableDataKey: "Outlet wise",
      defaultValue: "1",
      radioGroupItems: [
        {
          label: "Bill number wise",
          value: "1",
        },
        {
          label: "Outlet wise",
          value: "0",
        },
      ],
      isMandatory: true,
    },
   
    {
      label: "Bill Number",
      controlType: "textfield",
      placeHolder: "Bill Number",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "billNo",
      
    },
  ],
  secondaryOrderOutletWiseList: [
    {
      label: "Search By",
      controlType: "radiogroup",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "flag",
      tableDataKey: "Outlet wise",
      defaultValue: "1",
      radioGroupItems: [
        {
          label: "Sales executive wise",
          value: "1",
        },
        {
          label: "Outlet wise",
          value: "0",
        },
      ],
      isMandatory: true,
    },
    {
      label: "Beat",
      controlType: "autocomplete",
      placeHolder: "Select Beat ",
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "beatDetail",
      dataKey: "beat",
      getListId: "beat",
      isRootLevelKey: false,
      isMandatory: true,
    },
    {
      label: "Outlet",
      controlType: "multiSelect",
      placeHolder: "Select Outlet",
        md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      getListFrom:"beat",
      dataKey: "outletIds",
      masterName: "outletDetailByBeat",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],
  secondaryOrderSalesExecutiveWiseList: [
    {
      label: "Search By",
      controlType: "radiogroup",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "flag",
      tableDataKey: "Outlet wise",
      defaultValue: "1",
      radioGroupItems: [
        {
          label: "Sales executive wise",
          value: "1",
        },
        {
          label: "Outlet wise",
          value: "0",
        },
      ],
      isMandatory: true,
    },
   
    {
      label: "Sales executive ",
      controlType: "multiSelect",
      placeHolder: "Select Sales executive ",
        md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      dataKey: "salesExecutiveIds",
      masterName: "SalesExecutiveDetails",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],
  primaryOrderBillList: [
    {
      label: "From Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "fromdate",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "todate-le",
    },
    {
      label: "To Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "todate",
      onSubmit: "compare",
      onSubmitParameter: "fromdate-ge",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "fromdate-ge",
    }
   
  ],
};
